import {message, useIntl} from '@sail/intl';
import {media, tokens, view} from '@sail/ui';

import {TestmodeBadge} from 'src/components/core/TestmodeBadge';
import {useSelector} from 'src/fund/state/store';
import {useFundingSessionContext} from 'src/fund/state/useFundingSessionContext';
import {Link, MerchantLogo, Text} from 'src/v2/components/common';

const messages = {
  needHelp: message({
    id: 'crypto.payins.fund.header.need_help',
    description: 'Link to Stripe support from the hosted funding page',
    defaultMessage: 'Need help?',
  }),
};

export const Header = () => {
  const intl = useIntl();
  const logoUrl = useSelector((state) => state.logoUrl);
  const businessName = useSelector((state) => state.businessName);
  const {fundingSessionId} = useFundingSessionContext();
  // The internal view has no livemode field; Gen6 session IDs encode test mode.
  const testmode = fundingSessionId.startsWith('fndsess_test_');

  return (
    <view.div
      css={{
        stack: 'x',
        height: 'space.900',
        distribute: 'space-between',
        alignY: 'center',
        paddingX: 'space.500',
        paddingY: 'space.0',
        [media.down(tokens.viewport.medium)]: {
          height: '48px',
          paddingX: '16px',
        },
      }}
      data-testid="funding-header"
    >
      <view.div
        css={{
          stack: 'x',
          gap: 'small',
          alignY: 'center',
          width: 'fit',
        }}
      >
        <MerchantLogo
          logoUrl={logoUrl}
          businessName={businessName}
          style={{maxHeight: '32px', width: 'auto'}}
        />
        {testmode ? <TestmodeBadge /> : null}
      </view.div>

      <Link
        type="secondary"
        href="https://support.stripe.com/user/contact/email"
        target="_blank"
      >
        <Text type="body" css={{color: 'subdued'}}>
          {intl.formatMessage(messages.needHelp)}
        </Text>
      </Link>
    </view.div>
  );
};
